import { render, staticRenderFns } from "./SportCreateAndUpdateFormItems.vue?vue&type=template&id=1262d76c&"
import script from "./SportCreateAndUpdateFormItems.vue?vue&type=script&lang=js&"
export * from "./SportCreateAndUpdateFormItems.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/render/project/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1262d76c')) {
      api.createRecord('1262d76c', component.options)
    } else {
      api.reload('1262d76c', component.options)
    }
    module.hot.accept("./SportCreateAndUpdateFormItems.vue?vue&type=template&id=1262d76c&", function () {
      api.rerender('1262d76c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/SportCreateAndUpdateFormItems.vue"
export default component.exports